import { HeaderPlan } from "./headerPlan";
import { MainPlan } from "./mainPlan";

export const PlanPage = () => {
  return (
    <>
      <HeaderPlan />
      <MainPlan />
    </>
  );
};
